<script>
import { mapGetters } from 'vuex'

import Highlights from "@components/tabs/highlight-tab.vue";
import Tips from "@components/tabs/tips-tab.vue";
import Info from "@components/district/district-transport.vue";

export default {
  components: {
    Highlights,
    Tips,
    Info,
  },
  props: {
    district: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      HIGHLIGHT_TAB_NAME: 'Highlights',
      TIPS_TAB_NAME: 'Tips',
      INFO_TAB_NAME: 'Info',
      currentTab: 'Highlights'
    }
  },
  computed: {
    ...mapGetters('translations', [
      'currentLanguage'
    ]),
    districtTabs() {
      if (this.district.content) {
        return {
          highlights: this.isParam('highlights'),
          tips: this.isParam('tips'),
          info: true
        }
      }
      return {
        highlights: 0,
        tips: 0,
        info: true
      }
    },
  },
  methods: {
    isActiveClass(tabName) {
      return this.currentTab === tabName ? 'active' : ''
    },
    toggleTab(tabName) {
      this.currentTab = tabName
    },
    isParam(param) {
      const paramList = this.district.content[this.currentLanguage][param]
      const list = paramList && paramList.length ?
      this.district.content[this.currentLanguage] : this.district.content.en

      return list[param] ? list[param].filter(item => item).length : 0
    },
  },
  created() {
    const curtab = Object.entries(this.districtTabs).filter(item => item[1])[0][0]
    this.currentTab = curtab.charAt(0).toUpperCase() + curtab.slice(1)
  },
}
</script>

<template>
  <div class="tabs">
    <div class="tabs-container">
      <div
        v-if="districtTabs.highlights"
        class="highlight"
        :class="isActiveClass(HIGHLIGHT_TAB_NAME)"
        @click="toggleTab(HIGHLIGHT_TAB_NAME)"
      >
        <i></i>
      </div>
      <div
        class="info"
        :class="isActiveClass(INFO_TAB_NAME)"
        @click="toggleTab(INFO_TAB_NAME)"
      >
        <i></i>
      </div>
      <div
        v-if="districtTabs.tips"
        class="tip"
        :class="isActiveClass(TIPS_TAB_NAME)"
        @click="toggleTab(TIPS_TAB_NAME)"
      >
        <i></i>
      </div>
    </div>
    <div class="tab-container">
      <keep-alive>
        <component :is="currentTab" :object="district"></component>
      </keep-alive>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.tabs {
  width: 367px;
  height: 380px;
  background: $dark-blue;
  border-radius: 10px 10px 0 0;

  .tabs-container {
    display: flex;
    flex-direction: row;

    & div {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      flex-grow: 1;
      height: 50px;
      cursor: pointer;

      i {
        width: 30px;
        height: 30px;
      }

      &.active {
        background: $light-gray;
      }

      &.highlight {
        & i {
          background: url("../../assets/icons/star-highlight-incative.svg") no-repeat center;
        }
      }

      &.tip {
        i {
          background: url("../../assets/icons/lamp-icon-inactive.svg") no-repeat center;
        }
      }

      &.info {
        i {
          background: url("../../assets/icons/info-inactive.svg") no-repeat center;
        }
      }

      &.working-hours {
        i {
          background: url("../../assets/icons/clock-inactive.svg") no-repeat center;
        }
      }

      &.highlight.active {
        & i {
          background: url("../../assets/icons/star-highlight-active.svg") no-repeat center;
        }
      }

      &.tip.active {
        & i {
          background: url("../../assets/icons/lamp-icon-active.svg") no-repeat center;
        }
      }

      &.info.active {
        & i {
          background: url("../../assets/icons/info-active.svg") no-repeat center;
        }
      }
    }

    :first-child {
      border-radius: 8px 0px 0px 0px;
    }

    :last-child {
      border-radius: 0px 8px 0px 0px;
    }
  }

  .tab-container {
    height: 100%;
  }
}
</style>
